import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { PersonSwingIllustration } from '@restworld/utils-common';
import { Button, Title } from '../../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CoverLetterConfirmation = function CoverLetterConfirmation(_ref) {
  var onWriteCoverLetter = _ref.onWriteCoverLetter,
      onApplyWithoutCoverLetter = _ref.onApplyWithoutCoverLetter,
      loading = _ref.loading,
      variant = _ref.variant;

  var _useTranslation = useTranslation('onboarding-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs(SecondWrapperDiv, {
      isReversed: variant === 'two',
      children: [/*#__PURE__*/_jsx(PersonSwingIllustration, {
        width: 320,
        height: 260
      }), /*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [/*#__PURE__*/_jsx(Title, {
          content: t('launch_yourself_with_a_great_cover_letter'),
          fontSize: "extraLarge",
          fontWeight: "semibold",
          twStyle: {
            "lineHeight": "1.688rem"
          }
        }), /*#__PURE__*/_jsx(Title, {
          content: t('the_cover_letter_shows_interest_and_professionalism'),
          fontSize: "base",
          fontWeight: "normal",
          twStyle: {
            "lineHeight": "1.5rem"
          },
          textColor: "gray"
        })]
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onWriteCoverLetter,
        title: t('write_the_cover_letter'),
        variant: "normal",
        icon: "DocumentTextIcon",
        fullwidth: true
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onApplyWithoutCoverLetter,
        title: t('candidates_without_letter'),
        variant: "secondary-outline",
        fullwidth: true,
        fontColor: "gray",
        loading: loading
      })]
    })]
  });
};

var SecondWrapperDiv = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cover-letter-confirmation__SecondWrapperDiv",
  componentId: "sc-1no9sba-0"
})(["", " ", ""], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "2.5rem",
  "textAlign": "center"
}, function (_ref2) {
  var isReversed = _ref2.isReversed;
  return isReversed ? {
    "flexDirection": "column-reverse"
  } : {
    "flexDirection": "column"
  };
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-confirmation___StyledDiv",
  componentId: "sc-1no9sba-1"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "2.5rem",
  "textAlign": "center"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-confirmation___StyledDiv2",
  componentId: "sc-1no9sba-2"
})({
  "display": "flex",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-confirmation___StyledDiv3",
  componentId: "sc-1no9sba-3"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem"
});